import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { TextField, Autocomplete, MenuItem, InputAdornment, IconButton } from '@mui/material';
import {
    updateQcSample,
    createQcSample,
    getQcSampleDataById,
    deleteQcSample,
    searchQcSamples
} from '../../../../services/clinicPortalServices/qcSampleService.js';
import { getAllAnalytes } from '../../../../services/clinicPortalServices/analyteService.js';
import { fetchQcRanges } from '../../../../services/clinicPortalServices/qcRangeService.js';
import { getUserFullName } from '../../../../services/common/util.js';
import moment from 'moment';
import { MobileDatePicker } from '@mui/x-date-pickers';
import EventIcon from '@mui/icons-material/Event';
import { qcControlTypes } from '../../../../services/common/optionsData.js';
import toastr from 'toastr';
import Swal from 'sweetalert2';

export default class QcSampleDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCopy: this.props.isCopy || false,
            originalQcSampleId: this.props.originalQcSampleId || '',
            qcSampleId: this.props && this.props.qcSampleId ? this.props.qcSampleId : '',
            name: '',
            analyteIds: this.props.analyteIds ? this.props.analyteIds : [],
            controlType: this.props.controlType ? this.props.controlType : '',
            lotNumber: '',
            lotExpirationDate: '',
            errors: [],
            analytes: [],
            qcRanges: []
        };
    }

    componentDidMount() {
        if (this.state.qcSampleId) {
            this.loadDetails();
        }
        getAllAnalytes().then((res) => {
            if (res && res.data) {
                this.setState({ analytes: res.data });
            }
        });
        fetchQcRanges().then((res) => {
            if (res && res.data) {
                this.setState({ qcRanges: res.data });
            }
        });
    }

    loadDetails = () => {
        getQcSampleDataById(this.state.qcSampleId).then((res) => {
            const qcSampleInfo = res.data;
            this.setState({
                name: qcSampleInfo.name,
                analyteIds: qcSampleInfo.analyteIds || [],
                controlType: qcSampleInfo.controlType,
                lotNumber: qcSampleInfo.lotNumber,
                lotExpirationDate: qcSampleInfo.lotExpirationDate
                    ? moment(qcSampleInfo.lotExpirationDate, 'YYYYMMDD')
                    : ''
            });
        });
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
        if (e.target.name === 'controlType') {
            this.setState({ analyteIds: [] });
        }
    };

    hasError = (key) => {
        return this.state.errors.indexOf(key) !== -1;
    };

    saveChanges = () => {
        let errors = [];
        if (!this.state.name) {
            errors.push('name');
        }
        if (!this.state.analyteIds) {
            errors.push('analyteIds');
        }
        if (!this.state.controlType) {
            errors.push('controlType');
        }
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }

        // Check for duplicate lot number
        if (this.state.lotNumber) {
            searchQcSamples({
                lotNumber: { $regex: `^${this.state.lotNumber}$`, $options: 'i' }
            }).then((res) => {
                if (res.data && res.data.length > 0) {
                    // For edit mode, exclude the current record from the check
                    const duplicates = this.state.qcSampleId
                        ? res.data.filter((item) => item._id !== this.state.qcSampleId)
                        : res.data;

                    if (duplicates.length > 0) {
                        Swal.fire({
                            title: 'Duplicate Lot Number',
                            text: 'A QC Sample with this lot number already exists. Please use a different lot number.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                container:
                                    window.localStorage.getItem('appTheme') === 'Dark' &&
                                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                                    'dark-swal'
                            }
                        });
                        return;
                    }
                }
                // If no duplicate lot number, proceed with save
                this.proceedWithSave();
            });
        } else {
            // If no lot number provided, proceed with save
            this.proceedWithSave();
        }
    };

    proceedWithSave = () => {
        let qcSampleInfo = {
            name: this.state.name,
            analyteIds: this.state.analyteIds,
            controlType: this.state.controlType,
            lotNumber: this.state.lotNumber,
            lotExpirationDate: this.state.lotExpirationDate
                ? moment(this.state.lotExpirationDate).format('YYYYMMDD')
                : ''
        };

        if (this.state.isCopy) {
            // For copy: just create new record (no deletion needed)
            qcSampleInfo.createdBy = getUserFullName();
            createQcSample(qcSampleInfo)
                .then((res) => {
                    console.log('Response in then block:', res);
                    if (!res) {
                        // If res is undefined, it means there was an error
                        toastr.error('Error creating QC Sample. Please check the lot number.');
                        return;
                    }
                    if (res.status === 200) {
                        this.props.handleClose();
                        this.props.context.componentParent.loadGridData();
                        toastr.success('QC Sample is created successfully');
                    } else if (res.status === 400) {
                        toastr.error(res.message || 'Error creating QC Sample');
                    }
                })
                .catch((err) => {
                    console.error('Error in catch block:', err);
                    toastr.error(err?.message || 'Error creating QC Sample');
                });
        } else if (this.state.qcSampleId) {
            // Regular update
            qcSampleInfo._id = this.state.qcSampleId;
            updateQcSample(qcSampleInfo)
                .then((res) => {
                    console.log('Response in then block:', res);
                    if (!res) {
                        // If res is undefined, it means there was an error
                        toastr.error('Error updating QC Sample. Please check the lot number.');
                        return;
                    }
                    if (res.status === 200) {
                        this.props.handleClose();
                        this.props.context.componentParent.loadGridData();
                        toastr.success('QC Sample is updated successfully');
                    } else if (res.status === 400) {
                        toastr.error(res.message || 'Error updating QC Sample');
                    }
                })
                .catch((err) => {
                    console.error('Error in catch block:', err);
                    toastr.error(err?.message || 'Error updating QC Sample');
                });
        } else {
            // Regular create
            qcSampleInfo.createdBy = getUserFullName();
            createQcSample(qcSampleInfo)
                .then((res) => {
                    console.log('Response in then block:', res);
                    if (!res) {
                        // If res is undefined, it means there was an error
                        toastr.error('Error creating QC Sample. Please check the lot number.');
                        return;
                    }
                    if (res.status === 200) {
                        this.props.handleClose();
                        this.props.context.componentParent.loadGridData();
                        toastr.success('QC Sample is created successfully');
                    } else if (res.status === 400) {
                        toastr.error(res.message || 'Error creating QC Sample');
                    }
                })
                .catch((err) => {
                    console.error('Error in catch block:', err);
                    toastr.error(err?.message || 'Error creating QC Sample');
                });
        }
    };

    render() {
        let filteredAnalytes = [];
        if (this.state.controlType) {
            filteredAnalytes = this.state.qcRanges
                .filter((item) => item.controlType === this.state.controlType)
                .map((item) => item.analyteId)
                .filter((analyte) => analyte != null);
        }

        return (
            <div>
                <div className="row form-row">
                    <div className="col-12">
                        <div className="form-group">
                            <TextField
                                label="Name *"
                                name="name"
                                value={this.state.name}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <TextField
                                name="controlType"
                                label="Control Type *"
                                select
                                value={this.state.controlType}
                                onChange={this.handleChange}
                                disabled={this.props.controlType ? true : false}
                            >
                                {qcControlTypes.map((controlType) => {
                                    return (
                                        <MenuItem value={controlType} key={controlType}>
                                            {controlType}
                                        </MenuItem>
                                    );
                                })}
                            </TextField>
                            <div className={this.hasError('controlType') ? 'inline-errormsg' : 'hidden'}>
                                <i className="fa fa-exclamation-circle" aria-hidden="true">
                                    &nbsp;This field is required.
                                </i>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <Autocomplete
                                multiple
                                value={this.state.analyteIds}
                                options={filteredAnalytes}
                                getOptionLabel={(option) => {
                                    // Handle both object and string ID formats
                                    if (typeof option === 'string') {
                                        const analyte = filteredAnalytes.find((item) => item._id === option);
                                        return analyte ? analyte.name : '';
                                    }
                                    return option?.name || '';
                                }}
                                isOptionEqualToValue={(option, value) => {
                                    const optionId = typeof option === 'string' ? option : option?._id;
                                    const valueId = typeof value === 'string' ? value : value?._id;
                                    return optionId === valueId;
                                }}
                                onChange={(event, newValue) => {
                                    this.setState({ analyteIds: newValue });
                                }}
                                filterSelectedOptions
                                disableCloseOnSelect
                                renderInput={(params) => (
                                    <TextField {...params} label="Analytes *" variant="outlined" />
                                )}
                                disabled={this.props.controlType ? true : false}
                            />
                            <div className={this.hasError('analyteId') ? 'inline-errormsg' : 'hidden'}>
                                <i className="fa fa-exclamation-circle" aria-hidden="true">
                                    &nbsp;This field is required.
                                </i>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <TextField
                                label="Lot Number"
                                name="lotNumber"
                                value={this.state.lotNumber}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <MobileDatePicker
                                value={this.state.lotExpirationDate}
                                onChange={(dateTime) =>
                                    this.setState({
                                        lotExpirationDate: dateTime.$d
                                    })
                                }
                                label="Lot Expiration Date"
                                renderInput={(props) => (
                                    <TextField
                                        {...props}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton edge="end">
                                                        <EventIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        margine="none"
                                        error={false}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div
                        className="col-12"
                        style={{
                            paddingTop: '10px',
                            borderTop: '1px solid rgba(0,0,0,.2'
                        }}
                    >
                        <Button
                            style={{ float: 'right', marginLeft: '10px' }}
                            variant="primary"
                            onClick={this.saveChanges}
                        >
                            Save Changes
                        </Button>
                        <Button style={{ float: 'right' }} variant="secondary" onClick={this.props.handleClose}>
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
